import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { mockCustomer } from '../../constantsValues/MockCustomer';
import { apiInstance } from '../../services/Api';

export interface CustomerPerson {
	person_id?: string;
	firstname?: string;
	lastname?: string;
	cpr_nr?: string;
}

export interface CustomerAddress {
	street_number?: string;
	street_name?: string;
	building_no_and_letter?: string;
	postal_code?: number;
	city_name?: string;
}
export interface ContactDetail {
	detail: string;
	type:
		| 'firstname'
		| 'Mobile__c'
		| 'Phone'
		| 'Postal_Code__c'
		| 'Name'
		| 'Street_Number__c'
		| 'Floor__c'
		| 'Floor_Door__c'
		| 'Floor_Side_Code__c'
		| 'City__c'
		| 'Customer_Type__c'
		| 'LastName'
		| 'Street__c'
		| 'Email__c';
}

export interface CustomerState {
	customer_id?: string;
	customer_ids: string[];
	businessbrand?: string;
	account_list: { account_id: string; source_system: string }[];
	tags?: string;
	name?: string;
	person?: CustomerPerson;
	contact?: {
		address?: CustomerAddress;
		contact_details?: ContactDetail[];
	};
	isLoggedIn: boolean;
	isDataFetched: boolean;
	loading?: boolean;
	error?: any;
}

const initialState: CustomerState = {
	customer_id: undefined,
	customer_ids: [],
	businessbrand: undefined,
	account_list: [],
	tags: undefined,
	name: undefined,
	person: undefined,
	contact: undefined,
	isLoggedIn: false,
	isDataFetched: false,
};

export const loadCustomer = createAsyncThunk('token/validateToken', async (metaArea: MetaArea, { rejectWithValue }) => {
	try {
		//customerNo -> 9691310223
		// TODO Not Private customer
		// if (customer.tags?.includes(TagsEnum.BUSINESS)) {
		// BUSINESS = '#business',
		// BROKER = '#broker',
		// return;
		// }
		// or search for private tag: "tags": "#private #customer #insurance #CodanTIA",

		const ref = location.href.toLowerCase();
		// possible to mock customer on test environments -> add query param "customer=1"
		if (ref.includes('customer=') && (ref.startsWith('https://localhost') || ref.startsWith('https://sit-'))) {
			return await mockCustomer(false);
		}

		const productUrls = metaArea?.items?.[0]?.content;

		const axios = apiInstance();
		const auth: any = await axios.get(productUrls?.tokenExpireApiEndpoint?.url);
		if (auth?.authenticated) {
			return await axios.get(productUrls?.customerApiEndpoint?.url);
		}
		return rejectWithValue({ authenticated: false });
	} catch (error) {
		const formattedError = error as AxiosError;
		if (!formattedError?.response) {
			throw error;
		}
		const { data, status } = formattedError.response;
		return rejectWithValue({ data, status });
	}
});

export const customerSlice = createSlice({
	name: 'CustomerSlice',
	initialState,
	reducers: {
		setCustomer: (state, action: PayloadAction<any>) => {
			const fieldValues = action.payload;
			if (!fieldValues?.customer_id) return state;

			if (fieldValues.contact?.contact_details?.length > 0) {
				const cleanedContactDetails = fieldValues.contact?.contact_details?.filter(
					(contactDetail: ContactDetail) =>
						contactDetail.detail &&
						contactDetail.type &&
						contactDetail.detail.toLowerCase() !== 'null' &&
						contactDetail.detail.toLowerCase() !== 'undefined' &&
						contactDetail.detail.trim() !== ''
				);
				fieldValues.contact.contact_details = cleanedContactDetails;
			}
			//fieldValues.person.cpr_nr = '0510680044';

			state = { ...state, ...fieldValues };
			return state;
		},

		resetCustomer: (state) => {
			const { isLoggedIn, customer_id } = state;
			state = { ...initialState, isLoggedIn, customer_id };
			return state;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(loadCustomer.pending, (state) => {
			state.loading = true;
			state.error = null;
		});
		builder.addCase(loadCustomer.fulfilled, (state) => {
			state.loading = false;
			state.isLoggedIn = true;
			state.isDataFetched = true;
			state.error = null;
		});
		builder.addCase(loadCustomer.rejected, (state, action) => {
			state.loading = false;
			state.isLoggedIn = false;
			state.isDataFetched = true;
			state.error = action.payload;
		});
	},
});
export const { setCustomer, resetCustomer } = customerSlice.actions;
export default customerSlice.reducer;
